import { Link } from 'react-router-dom';

const blogArticles = [
  {
    slug: '/guide/gtbuy-sheet-ultimate-guide-2026',
    title: 'GTBuy Sheet: The Ultimate 2026 Spreadsheet Shopping Guide',
    summary:
      'Everything you need to know about spreadsheet shopping — how GTBuy Sheet works, why it beats traditional browsing, and how to find the best deals across all 14 categories.',
    icon: 'ri-guide-line',
  },
];

export default function BlogSection() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-100">
      <div className="text-center mb-12 md:mb-16">
        <span className="inline-block px-4 py-1.5 rounded-full border border-secondary-300 text-secondary-700 text-xs font-medium tracking-wider uppercase mb-4">
          SEO Guides
        </span>
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 max-w-2xl mx-auto leading-tight">
          Spreadsheet Shopping <span className="italic text-primary-500">Resources</span>
        </h2>
        <p className="mt-4 text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
          In-depth guides and tutorials to help you master spreadsheet shopping and get the most out of GTBuy Sheet.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
        {blogArticles.map((article) => (
          <Link
            key={article.slug}
            to={article.slug}
            className="group block rounded-2xl p-6 md:p-8 bg-background-50 border border-background-200/60 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300"
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 mb-5 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
              <i className={`${article.icon} w-5 h-5 flex items-center justify-center`}></i>
            </div>
            <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug">
              {article.title}
            </h3>
            <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
              {article.summary}
            </p>
            <div className="mt-5 flex items-center gap-2 text-sm font-medium text-primary-500 group-hover:text-primary-600 transition-colors">
              Read Guide
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform"></i>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}